var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._g(_vm._b({attrs:{"max-width":"1200"}},'v-dialog',_vm.$attrs,false),_vm.$listeners),[(_vm.videoUrl && _vm.$attrs.value)?_c('v-responsive',{attrs:{"aspect-ratio":16 / 9}},[_c('iframe',{staticClass:"yt-video",attrs:{"src":_vm.videoUrl,"width":"100%","height":"100%","frameborder":"0","allowfullscreen":""}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }